import { KeyboardEvent, useState } from 'react'

type UseRejectReasonFormOptions = {
  onReject: (reason: string | null) => void
  onOpenChange?: (isOpen: boolean) => void
}

export default function useRejectReasonForm({
  onReject,
  onOpenChange,
}: UseRejectReasonFormOptions) {
  const [isOpen, setIsOpen] = useState(false)
  const [reason, setReason] = useState('')

  const open = () => {
    setIsOpen(true)
    onOpenChange?.(true)
  }

  const close = () => {
    setIsOpen(false)
    setReason('')
    onOpenChange?.(false)
  }

  const confirm = () => {
    onReject(reason.trim() || null)
    close()
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Escape' || !isOpen) return
    // Escape closes the reject form. Stop the key event here. If it reached
    // the document viewer's Modal, Escape would close the whole viewer too.
    event.stopPropagation()
    close()
  }

  return { isOpen, reason, setReason, open, close, confirm, handleKeyDown }
}
